// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkWithImage_link__Z3I_g"};